// extracted by mini-css-extract-plugin
module.exports = {"formattedTableItems":"_19l7RgJHsRM_BQAWkT4mkP","tableContainer":"_2WA1fOtzQStJjMrlz2y9zI","content":"_1Hgm_Fz-84hcRdi_iCxYfR"};